import { render, staticRenderFns } from "./DocumentEditForm.vue?vue&type=template&id=fb012a38&"
import script from "./DocumentEditForm.vue?vue&type=script&lang=js&"
export * from "./DocumentEditForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEditForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports